import { useSecurityContext } from './useSecurityContext';

const Logout = ({ render }) => {
  const { logout } = useSecurityContext();
  return render(logout);
};
export default Logout;